// 자동 생성 - 디스크의 session-*.js 목록 (scripts/promote-backlog.py가 갱신)
// examData.js가 이 매니페스트를 머지하여 파일이 존재하면 자동 등록됩니다.
export const sessionsManifest = {
  "architectural-engineer": {
    "2021": [
      1,
      2,
      4
    ],
    "2022": [
      1,
      2,
      4
    ],
    "2023": [
      1,
      2,
      4
    ],
    "2024": [
      2,
      3
    ]
  },
  "computer-applications-level1": {
    "2022": [
      1,
      2,
      3,
      4
    ],
    "2023": [
      1,
      2,
      3,
      4
    ],
    "2024": [
      1,
      2,
      3,
      4
    ]
  },
  "computer-applications-level2": {
    "2022": [
      1,
      2,
      3,
      4
    ],
    "2023": [
      1,
      2,
      3,
      4
    ],
    "2024": [
      1,
      2,
      3,
      4
    ]
  },
  "confectionery-technician": {
    "2009": [
      2,
      4,
      5
    ],
    "2010": [
      1,
      2,
      4,
      5
    ],
    "2011": [
      1,
      2,
      4,
      5
    ]
  },
  "electrical-construction-engineer": {
    "2021": [
      1,
      2,
      4
    ],
    "2022": [
      1,
      2
    ]
  },
  "electrical-engineer": {
    "2015": [
      1,
      2,
      3
    ],
    "2016": [
      1,
      2,
      3
    ],
    "2017": [
      1,
      2,
      3
    ],
    "2018": [
      1,
      2,
      3
    ],
    "2019": [
      1,
      2
    ],
    "2020": [
      2,
      3
    ],
    "2021": [
      1,
      2,
      3
    ],
    "2022": [
      1,
      2
    ],
    "2023": [
      1,
      2,
      3
    ],
    "2024": [
      1,
      2,
      3
    ]
  },
  "electrical-industrial-engineer": {
    "2021": [
      1,
      2
    ],
    "2022": [
      1,
      2,
      3
    ],
    "2023": [
      1,
      2,
      3
    ],
    "2024": [
      1,
      2,
      3
    ]
  },
  "electrical-technician": {
    "2013": [
      1,
      2,
      4,
      5
    ],
    "2014": [
      1,
      2,
      4,
      5
    ],
    "2015": [
      1,
      2,
      4,
      5
    ],
    "2016": [
      1,
      2,
      4
    ],
    "2019": [
      2,
      3
    ],
    "2020": [
      1,
      2,
      3
    ],
    "2025": [
      4
    ]
  },
  "excavator-operator": {
    "2009": [
      1,
      2,
      4,
      5
    ],
    "2010": [
      1,
      2,
      4,
      5
    ],
    "2011": [
      1,
      2,
      4,
      5
    ],
    "2013": [
      5
    ]
  },
  "fire-engineer-mechanic": {
    "2020": [
      2,
      3,
      4
    ],
    "2021": [
      1,
      2,
      4
    ],
    "2022": [
      1,
      2
    ]
  },
  "fire-protection-engineer-electrical": {
    "2020": [
      2,
      3,
      4
    ],
    "2021": [
      1,
      2,
      4
    ],
    "2022": [
      1,
      2
    ]
  },
  "forest-technician": {
    "2011": [
      1,
      2,
      3
    ],
    "2012": [
      1,
      2
    ],
    "2013": [
      1,
      2,
      3
    ],
    "2014": [
      1,
      2,
      3
    ],
    "2015": [
      1,
      2,
      3
    ],
    "2016": [
      1,
      2,
      3
    ]
  },
  "forklift-operator-technician": {
    "2010": [
      1,
      2,
      4,
      5
    ],
    "2011": [
      1,
      2,
      4,
      5
    ]
  },
  "hazardous-materials-industrial-engineer": {
    "2018": [
      1,
      2,
      4
    ],
    "2019": [
      1,
      2,
      4
    ],
    "2020": [
      2,
      3
    ]
  },
  "hvac-refrigeration-industrial-engineer": {
    "2018": [
      1,
      2,
      3
    ],
    "2019": [
      1,
      2,
      3
    ],
    "2020": [
      2,
      3
    ]
  },
  "industrial-hygiene-engineer": {
    "2018": [
      1,
      2,
      3
    ],
    "2019": [
      1,
      2,
      3
    ],
    "2020": [
      1,
      2,
      3
    ],
    "2021": [
      1,
      2,
      3
    ],
    "2022": [
      1,
      2
    ]
  },
  "industrial-safety-engineer": {
    "2020": [
      2,
      3,
      4
    ],
    "2021": [
      1,
      2,
      3
    ],
    "2022": [
      1,
      2,
      3
    ]
  },
  "industrial-safety-industrial-engineer": {
    "2016": [
      1,
      2,
      3
    ],
    "2017": [
      1,
      2,
      3
    ],
    "2018": [
      1,
      2,
      3
    ],
    "2019": [
      1,
      2,
      3
    ],
    "2020": [
      2,
      3
    ]
  },
  "information-processing-engineer": {
    "2020": [
      2,
      3,
      4
    ],
    "2021": [
      1,
      2,
      3
    ],
    "2022": [
      1,
      2,
      3
    ],
    "2023": [
      1,
      2,
      3
    ],
    "2024": [
      1,
      2,
      3
    ]
  },
  "korean-cooking-technician": {
    "2012": [
      1,
      2,
      4,
      5
    ],
    "2013": [
      1,
      2,
      4,
      5
    ],
    "2014": [
      1,
      2,
      5
    ],
    "2015": [
      1,
      2,
      5
    ],
    "2016": [
      1
    ]
  }
};

export default sessionsManifest;
